import React from 'react';
import { connect } from 'react-redux';
import { DBRadioButton, DBTextArea } from '_components';
import styles from './Common.module.css'

class PatientCareCenterNotePlanBodyDN extends React.Component {

    render() {
        return (
            <div>
                <div className={styles.row}>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLPROGRESSING'
                        label="Patient's plan is progressing"
                        selectedValue={true}
                    />
                </div>
                <div className={styles.row}>
                    <DBRadioButton
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLPROGRESSING'
                        label="Patient's plan is not progressing"
                        selectedValue={false}
                    />
                </div>

                <div className={styles.row}>
                    {this.props.isProgressing &&
                        <b>Comments:</b>
                    }
                    {!this.props.isProgressing &&
                        <span className={styles.required}>Comments:</span>
                    }
                </div>

                <div className={styles.row}>
                    <DBTextArea
                        noteId={this.props.noteId}
                        entity='PTPLAN'
                        entityKeyColumn='PLNO'
                        entityKeyValue={this.props.plno}
                        field='PLCOMMENTS'
                        className={styles.textarea}
                    />
                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let plno = parseInt(Object.keys(state.entities.notes.PTPLAN)
        .find(key => (state.entities.notes.PTPLAN[key].PLEVNO === pk && noteType === 1)
            || (state.entities.notes.PTPLAN[key].PLNTNO === pk && noteType !== 1)));
    let isProgressing = state.entities.notes.PTPLAN[plno].PLPROGRESSING !== null && state.entities.notes.PTPLAN[plno].PLPROGRESSING !== undefined ? state.entities.notes.PTPLAN[plno].PLPROGRESSING : true;

    return {
        noteId,
        plno,
        isProgressing
    };
}

const connectedPatientCareCenterNotePlanBodyDN = connect(mapStateToProps)(PatientCareCenterNotePlanBodyDN);
export { connectedPatientCareCenterNotePlanBodyDN as PatientCareCenterNotePlanBodyDN };

